import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ActivationService } from '../services/activation.service';

export const activationGuard: CanActivateFn = async (_route, _state) => {
  const activationService = inject(ActivationService);
  if (activationService.isActivated()) return true;

  const router = inject(Router);
  await router.navigate(['activation']);

  return false;
};
